import { createContext, useCallback, useContext, useState } from "react";

const RefreshCtx = createContext({ refreshKey: 0, refresh: () => {} });

export const RefreshProvider = ({ children }) => {
  const [refreshKey, setKey] = useState(0);
  const refresh = useCallback(() => setKey((k) => k + 1), []);
  return <RefreshCtx.Provider value={{ refreshKey, refresh }}>{children}</RefreshCtx.Provider>;
};

export const useRefresh = () => useContext(RefreshCtx);

// Remounts the current page so every section re-fetches the latest data the team has saved.
export const RefreshableRoutes = ({ children }) => {
  const { refreshKey } = useRefresh();
  return <div key={refreshKey} className="contents">{children}</div>;
};
